import type { ActivityIngredient } from '@apps/main/modules/recipe/ingredients';

import type { SelectedTicketInfo } from '@libs/trip-planner-interfaces';

import {
  ACTIVITY_PROPS_SEPARATOR,
  ACTIVITY_TICKETS_SEPARATOR,
  SELECTED_TICKET_PREFIX,
  TICKET_PROPS_SEPARATOR,
  TICKET_PROPS_WRAPPER_CLOSE,
  TICKET_PROPS_WRAPPER_OPEN,
} from './constants';

export function serializeActivity(activity: ActivityIngredient): string {
  const activityParameters = [
    activity.code,
    activity.offset,
    serializeTickets(activity.tickets),
  ].join(ACTIVITY_PROPS_SEPARATOR);

  return `${SELECTED_TICKET_PREFIX}${activityParameters}`;
}

function serializeTickets(tickets: SelectedTicketInfo[]): string {
  return tickets
    .map((ticket) => {
      const ticketProps = [
        ticket.rateId ?? '',
        ticket.ageRangeId ?? '',
        ticket.getQuantityFromPax ? '' : ticket.quantity,
        ticket.timeSlotId ? encodeURIComponent(ticket.timeSlotId) : '',
        ticket.getQuantityFromPax ? 1 : 0,
      ].join(TICKET_PROPS_SEPARATOR);

      return `${TICKET_PROPS_WRAPPER_OPEN}${ticketProps}${TICKET_PROPS_WRAPPER_CLOSE}`;
    })
    .join(ACTIVITY_TICKETS_SEPARATOR);
}
